<template>
  <div class="recruitment-small-recap-component">
    <div v-if="recruitment.isAE()" class="recruitment-small-recap-items q-mt-md">
      <QIcon name="fa fa-calendar-day" size="xs" />
      <p class="text-bold q-ml-md">
        {{ datesDisplay }}
      </p>
    </div>
    <div v-if="recruitment.isAutoBooking()" class="recruitment-small-recap-items">
      <QIcon name="fa fa-wand-magic-sparkles" size="xs" />
      <p class="text-bold q-ml-md">
        {{ $t("ETAB.PAGES.RECRUITMENT.TILE.@MISSION_AUTO_BOOK") }}
      </p>
    </div>
    <div class="text-right">
      <QBtn rounded flat no-caps :label="$t('ETAB.BUTTONS.@SEE_MORE')" class="btn" @click="$emit('openRecruitmentRecap')" />
    </div>
  </div>
</template>

<script>
  import { Recruitment } from "@core/models";

  export default {
    props: {
      recruitment: {
        type: Object,
        default: () => Recruitment,
      },
    },
    emits: ["openRecruitmentRecap"],
    computed: {
      datesDisplay() {
        const startTest = this.recruitment.getStartDate();
        if (startTest) {
          const startDate = this.recruitment.getStartDate();
          const startingTime = this.recruitment.getStartingDateTime();
          const endDate = this.recruitment.getEndDate();

          if (startingTime === undefined) {
            const start = startDate.format("ddd DD/MM");
            const end = endDate.format("DD/MM");
            return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@DATES_DISPLAY_NO_TIME", { start, end });
          }

          if (this.recruitment.isOneDay()) {
            const date = startDate.format("ddd DD/MM");
            const time = startingTime.format("HH[h]mm");
            return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@DATES_DISPLAY_SINGLE", { date, time });
          }

          const start = startDate.format("ddd DD/MM");
          const time = startingTime.format("HH[h]mm");
          const end = endDate.format("DD/MM");
          return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@DATES_DISPLAY", { start, time, end });
        }

        return "Dès que possible";
      },
      missionDuration() {
        const duration = this.recruitment.getDuration();
        return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@MISSION_DURATION", { duration });
      },
      missionAddressDisplay() {
        const address = this.recruitment.getCurrentEtablissement().getFormattedAddress();
        return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@MISSION_ADDRESS_DISPLAY", { address });
      },
    },
  };
</script>

<style lang="scss">
  .recruitment-small-recap-component {
    background-color: #ffffff;
    box-shadow: $card-shadow;
    border-radius: 4%;
    padding: 15px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .recruitment-small-recap-items {
      display: flex;
      > p {
        align-self: center;
      }
    }
    .btn {
      .block {
        text-decoration: underline;
      }
    }
  }
</style>
